<script lang="ts" setup>
  import type { DefineComponent } from 'vue'

  withDefaults(
    defineProps<{
      id: string
      rootPage: DefineComponent<any, any, any> // Use the Vue component constructor type
      backgroundColor?: string
    }>(),
    {
      backgroundColor: 'var(--color-base-white)'
    }
  )
</script>

<template>
  <ion-nav :id="id" :root="rootPage" />
</template>

<style lang="scss" scoped>
  ion-nav {
    background-color: v-bind('backgroundColor');
  }
</style>
